// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form {\n  line-height: 2.5em;\n  font-size: 12px;\n  font-size: 0.75rem; }\n  .form--naked {\n    display: inline;\n    line-height: inherit;\n    font-size: inherit; }\n  .form__row {\n    margin-top: 10px; }\n  .form__row--buttons {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: center;\n          -ms-flex-pack: center;\n              justify-content: center; }\n  .form__row--buttons .button {\n        margin: 0 8px;\n        margin: 0 0.5rem; }\n  .form__message {\n    margin: 16px 0;\n    margin: 1rem 0;\n    text-align: center;\n    font-size: 12px;\n    font-size: 0.75rem; }\n  .form__message--label {\n      margin-right: 8px;\n      margin-right: 0.5rem; }\n  .form__note {\n    font-weight: 600; }\n  .form__error-message {\n    line-height: 1.5em;\n    font-size: 12px;\n    font-size: 0.75rem;\n    color: #bb1616; }\n  .form__error-message--bottom {\n      text-align: center; }\n  .form__label {\n    display: block;\n    font-family: Poppins, sans-serif;\n    font-weight: 500 !important;\n    color: #000; }\n  .form__input {\n    border: 1px solid #c2c2c2;\n    border-radius: 4px;\n    width: calc(100% - 0.37rem - 2px);\n    padding: 2.96px;\n    padding: 0.185rem;\n    font-size: 12px;\n    font-size: 0.75rem; }\n  .form__input:not(:disabled):hover, .form__input:not(:disabled):focus {\n      border-color: #000;\n      outline: none; }\n", ""]);
// Exports
exports.locals = {
	"form": "form",
	"form--naked": "form--naked",
	"form__row": "form__row",
	"form__row--buttons": "form__row--buttons",
	"button": "button",
	"form__message": "form__message",
	"form__message--label": "form__message--label",
	"form__note": "form__note",
	"form__error-message": "form__error-message",
	"form__error-message--bottom": "form__error-message--bottom",
	"form__label": "form__label",
	"form__input": "form__input"
};
module.exports = exports;



//////////////////
// WEBPACK FOOTER
// ./~/css-loader/dist/cjs.js?{"modules":{"localIdentName":"[local]"}}!./~/postcss-loader/lib!./~/sass-loader!./components/form/form.scss
// module id = hIya
// module chunks = 1